import constants from './constants/index'
import methods from './methods/index'

const globals = {
    constants: constants,
    methods: methods
};

export default globals;